<template>
  <div>
    <div class="login-container">
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1879d6e34697b974969b2590245da84d.png"
        alt=""
      />
      <div class="btn" @click="bindRegister">注册绑定</div>
    </div>
    <MyLogin
      v-if="showLogin"
      class="login-content"
      title="请填写以下信息，完成注册，绑定懒人定量饭盒"
      @close="bindLoginClose"
      @login="bindLogin"
    ></MyLogin>
  </div>
</template>
<script>
import MyLogin from '@/components/app/login/login.vue'
export default {
  components: {
    MyLogin
  },
  data() {
    return {
      showLogin: false
    }
  },
  mounted() {
    /* this.screenHeight = window.innerHeight + 'px';
      window.addEventListener("visibilitychange",()=>{
       if(document.visibilityState === 'visible'){
         window.innerHeight = 900;
       }
      }); */
  },
  methods: {
    bindRegister() {
      this.showLogin = true
    },
    bindLoginClose() {
      this.showLogin = false
    },
    bindLogin(options) {
      let params = {
        phone: options.phone,
        identify_code: options.code,
        areaCode: '86',
        gender: '0',
        r_from: '6'
      }
      this.$http
        .postBaseApp('member/WaterClock/registerWaterUser', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast(res.data.msg || '注册成功')
            setTimeout(() => {
              this.$router.push('/eating-today/register-success')
            }, 500)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch()
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100vh;
  position: relative;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/58f7ae3c458237de8caf674ff2bbe123.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .image {
    margin-top: 40px;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    object-fit: contain;
  }
  .btn {
    text-align: center;
    width: 283px;
    height: 42px;
    line-height: 42px;
    background: #6236ff;
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-top: 5.6vh;
    margin-bottom: 9vh;
  }
}
.login-content {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>
